export default __webpack_public_path__ + "static/media/cif-gd.815adc13.svg";